const loggedWorkoutIcon = "mdi mdi-blur-linear";
const loggedScoreIcon = "mdi mdi-flag";
const gymIcon = "mdi mdi-weight-kilogram";
const totalWorkoutIcon = "mdi mdi-dumbbell";
const trackIcon = "mdi mdi-radar";
const commentIcon = "mdi mdi-message-text";
const likeIcon = "mdi mdi-thumb-up";
const totalAthletes = "mdi mdi-human-male";

export const athleteStatsInfo = {
  Overviews: [
    {
      name: "TotalGyms",
      title: "Gyms",
      value: null,
      iconClasses: `${gymIcon} text-primary`,
      iconImage: null,
    },
    {
      name: "TotalLoggedWorkouts",
      title: "Logged Workouts",
      value: null,
      iconClasses: `${loggedWorkoutIcon} text-success`,
      iconImage: null,
    },
    {
      name: "TotalWorkouts",
      title: "Total Workouts",
      value: null,
      iconClasses: `${totalWorkoutIcon} text-warning`,
      iconImage: null,
    },
    {
      name: "TotalTracksJoined",
      title: "Tracks",
      value: null,
      iconClasses: `${trackIcon} text-danger`,
      iconImage: null,
    },
  ],
  Engagements: [
    {
      name: "TotalCommentsPosted",
      title: "Comments Posted",
      value: null,
      iconClasses: `${commentIcon} text-success`,
      iconImage: null,
    },
    {
      name: "TotalLikesGiven",
      title: "Likes Given",
      value: null,
      iconClasses: `${likeIcon} text-info`,
      iconImage: null,
    },
    {
      name: "TotalLikesRecieved",
      title: "Likes Recieved",
      value: null,
      iconClasses: `${likeIcon} text-primary`,
      iconImage: null,
    },
    {
      name: "TotalLoggedScores",
      title: "Logged Scores",
      value: null,
      iconClasses: `${loggedScoreIcon} text-warning`,
      iconImage: null,
    },
  ],
};

export const gymStatsInfo = {
  Overviews: [
    {
      name: "TotalAthletes",
      title: "Athletes",
      value: null,
      iconClasses: `${totalAthletes} text-primary`,
      iconImage: null,
    },
    {
      name: "TotalTracks",
      title: "Tracks",
      value: null,
      iconClasses: `${trackIcon} text-danger`,
      iconImage: null,
    },
    {
      name: "TotalWorkouts",
      title: "Workouts",
      value: null,
      iconClasses: `${totalWorkoutIcon} text-warning`,
      iconImage: null,
    },
    {
      name: "TotalLoggedWorkouts",
      title: "Logged Workouts",
      value: null,
      iconClasses: `${loggedWorkoutIcon} text-success`,
      iconImage: null,
    },
  ],
  Engagements: [
    {
      name: "TotalLoggedScores",
      title: "Logged Scores",
      value: null,
      iconClasses: `${loggedScoreIcon} text-warning`,
      iconImage: null,
    },
    {
      name: "TotalCommentsOnLoggedWorkouts",
      title: "Comments",
      value: null,
      iconClasses: `${commentIcon} text-success`,
      iconImage: null,
    },
    {
      name: "TotalLikesOnLoggedWorkouts",
      title: "Likes",
      value: null,
      iconClasses: `${likeIcon} text-primary`,
      iconImage: null,
    },
  ],
};
